import { IState } from '../../store';

export const selectFullscreenGalleryOpened = (state: IState) => state.gallery.isFullScreen;
